import { useRef } from 'react';

export const useImageLoaderRef = () => {
  const imageloaderRef = useRef<HTMLDivElement>(null);

  const onLoadHandler = () => {
    imageloaderRef.current?.classList.add('hidden');
  };

  return { imageloaderRef, onLoadHandler };
};
